// used to mimic sui-badge style
// we are not able to use sui-badge directly in autocomplete as they may have icons and delete buttons

import { Chip, styled } from "@mui/material";

// and pointer events do not work
export const Badge = styled(Chip)(() => ({
  borderRadius: '12px',
  padding: '6px 8px',
}))